import { register } from 'register-service-worker'

// Create event bus for service worker updates
export const updateEventBus = {
  callbacks: [],
  emit(data) {
    this.callbacks.forEach(callback => callback(data));
  },
  on(callback) {
    this.callbacks.push(callback);
  }
};

register('/service-worker.js', {
  registrationOptions: { scope: './' },
  ready () {
    console.log('Service worker is active.')
  },
  registered (registration) {
    console.log('Service worker has been registered.')
    
    // Check for updates every 60 seconds
    setInterval(() => {
      registration.update();
    }, 60000);
  },
  cached () {
    console.log('Content has been cached for offline use.')
  },
  updatefound () {
    console.log('New content is downloading.')
  },
  updated (registration) {
    console.log('New content is available; please refresh.')
    
    // Emit update event to notify the app
    updateEventBus.emit({ 
      type: 'SW_UPDATED',
      registration 
    });
  },
  offline () {
    console.log('No internet connection found. App is running in offline mode.')
  },
  error (error) {
    console.error('Error during service worker registration:', error)
  }
});
